export function useOrganizationPicker() {
  const auth = useAuthorizeStore()

  const sessionApi = useSessionApi()

  const { time } = useServerTiming()

  const hasConfirmedSelectedOrganization = useCookie(
    '__confirmedOrgSelection',
    {
      sameSite: 'lax',
      secure: true,
      default: () => false,
    },
  )

  const organizations = computed(() => auth.user?.schoolOrganizations ?? [])

  const selectedOrganization = ref(auth.user?.selectedOrganization?.number)

  return {
    hasConfirmedSelectedOrganization,
    selectedOrganization,
    organizations,

    async handleConfirm() {
      const newOrg = organizations.value.find(
        (org) => org.number === selectedOrganization.value,
      )

      const old = auth.user?.selectedOrganization
      const orgNo = newOrg?.number
      if (orgNo) {
        if (orgNo !== old?.number) {
          try {
            await time('setActiveOrganization', () =>
              sessionApi.setSessionAttributes({
                activeOrganization: orgNo,
                activeOrganizationName: newOrg?.name ?? '',
              }))

            await auth.refreshUserData()
          } catch (error) {
            handleError(error, 'Error updating active organization', false)
            return false
          }
        }

        hasConfirmedSelectedOrganization.value = true
      }

      return true
    },
  }
}
